import { Container, Image } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import { Footer } from "./components/Footer";
import React from "react";
import PreCheckInWizard from "./PreCheckInWizard";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";

export type CheckInProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export const CheckIn = (props:CheckInProps) => {
  return (
    <Container style={{ maxWidth: "100%", padding: "0px" }}>
      <NavBar />
      <div className="banner-section">
        <div>
          <Image
            style={{
              width: "100%",
            }}
            src={require("./reception.jpg")}
          ></Image>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>
        </div>
        <div className="content-box">
          <h1 data-animation-in="fadeInUp" data-delay-in="0.3">
            Prepare for Your Stay
          </h1>
          <span
            className="sub-title"
            data-animation-in="fadeInUp"
            data-delay-in="0.1"
          >
            Welcome! To ensure a seamless check-in experience, please complete
            your pre-check-in steps. This will help us prepare for your arrival
            and expedite your check-in process.
          </span>
          <a
            href="#checkin-wizard"
            className="btn"
            data-animation-in="fadeInUp"
            data-delay-in="0.5"
            style={{ width: "210px" }}
          >
            Pre Check-In
          </a>
        </div>
      </div>

      <div
        id="checkin-wizard"
        className="pre-check-in-box"
        style={{ margin: "200px 100px 0px 100px" }}
      >
        <PreCheckInWizard payload={props.payload} />
      </div>
      <Footer />
    </Container>
  );
};
